import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { DashboardBlocksName } from 'types';

export const selectDashboardNewCases = (state: RootState) => state.dashboard.dashboardNewPatientCases;
export const selectDashboardLetterCases = (state: RootState) => state.dashboard.dashboardLetterPatientCases;
export const selectDashboardInTreatmentCases = (state: RootState) => state.dashboard.dashboardInTreatmentPatientCases;
export const selectDashboardFinishedCases = (state: RootState) => state.dashboard.dashboardFinishedPatientCases;
export const selectDashboardOutOfTreatmentCases = (state: RootState) =>
  state.dashboard.dashboardOutOfTreatmentPatientCases;

export const selectDashboardNewCasesInfo = (state: RootState) => state.dashboard.dashboardNewPatientCasesListInfo;
export const selectDashboardLetterCasesInfo = (state: RootState) => state.dashboard.dashboardLetterPatientCasesListInfo;
export const selectDashboardInTreatmentCasesInfo = (state: RootState) =>
  state.dashboard.dashboardInTreatmentPatientCasesListInfo;
export const selectDashboardFinishedCasesInfo = (state: RootState) =>
  state.dashboard.dashboardFinishedPatientCasesListInfo;

export const selectDashboardOutOfTreatmentCasesInfo = (state: RootState) =>
  state.dashboard.dashboardOutOfTreatmentPatientCasesListInfo;

export const selectDashboardNewCasesFilter = (state: RootState) => state.dashboard.dashboardNewCasesFilter;
export const selectDashboardLetterCasesFilter = (state: RootState) => state.dashboard.dashboardLetterCasesFilter;
export const selectDashboardInTreatmentCasesFilter = (state: RootState) =>
  state.dashboard.dashboardInTreatmentCasesFilter;
export const selectDashboardFinishedCasesFilter = (state: RootState) => state.dashboard.dashboardFinishedCasesFilter;
export const selectDashboardOutOfTreatmentCasesFilter = (state: RootState) =>
  state.dashboard.dashboardOutOfTreatmentCasesFilter;

export const selectDashboardNewCasesLoading = (state: RootState) =>
  state.dashboard.asyncActionsAreLoading.getPatientCasesDashboardNew;
export const selectDashboardLetterCasesLoading = (state: RootState) =>
  state.dashboard.asyncActionsAreLoading.getPatientCasesDashboardLetter;
export const selectDashboardInTreatmentCasesLoading = (state: RootState) =>
  state.dashboard.asyncActionsAreLoading.getPatientCasesDashboardInTreatment;
export const selectDashboardFinishedCasesLoading = (state: RootState) =>
  state.dashboard.asyncActionsAreLoading.getPatientCasesDashboardFinished;
export const selectDashboardOutOfTreatmentCasesLoading = (state: RootState) =>
  state.dashboard.asyncActionsAreLoading.getPatientCasesDashboardOutOfTreatment;

export const selectFeedMessagesAmount = (state: RootState) => state.dashboard.feedAmount;
export const selectFeedMessages = (state: RootState) => state.dashboard.feed;
export const selectFeedMessagesInfo = (state: RootState) => state.dashboard.feedInfo;
export const selectFeedMessagesFilter = (state: RootState) => state.dashboard.feedFilter;
export const selectFeedMessagesAmountIsLoading = (state: RootState) =>
  state.dashboard.asyncActionsAreLoading.getFeedMessagesAmount;
export const selectFeedMessagesIsLoading = (state: RootState) => state.dashboard.asyncActionsAreLoading.getFeed;

export const selectDashboardFilter = (state: RootState) => state.dashboard.dashboardFilter;
export const selectActiveFeedTab = (state: RootState) => state.dashboard.activeFeedTab;

export const selectDashboardLoadingStates = createSelector(
  [
    selectDashboardNewCasesLoading,
    selectDashboardLetterCasesLoading,
    selectDashboardInTreatmentCasesLoading,
    selectDashboardFinishedCasesLoading,
    selectDashboardOutOfTreatmentCasesLoading,
  ],
  (newCasesLoading, letterCasesLoading, inTreatmentCasesLoading, finishedCasesLoading, outOfTreatmentCasesLoading) => ({
    'New patients': newCasesLoading,
    'Letter review': letterCasesLoading,
    'In treatment': inTreatmentCasesLoading,
    Finished: finishedCasesLoading,
    'Out of treatment': outOfTreatmentCasesLoading,
  }),
);
